export const wagePercentiles = [
  { percentile: 0.0, z_score: -17.470221038 },
  { percentile: 0.01, z_score: -2.102470718 },
  { percentile: 0.02, z_score: -1.657692267 },
  { percentile: 0.03, z_score: -1.447787247 },
  { percentile: 0.04, z_score: -1.305352576 },
  { percentile: 0.05, z_score: -1.191553838 },
  { percentile: 0.06, z_score: -1.096984835 },
  { percentile: 0.07, z_score: -1.019325506 },
  { percentile: 0.08, z_score: -0.9549734046 },
  { percentile: 0.09, z_score: -0.9008792568 },
  { percentile: 0.1, z_score: -0.8541063735 },
  { percentile: 0.11, z_score: -0.8136309619 },
  { percentile: 0.12, z_score: -0.7767667659 },
  { percentile: 0.13, z_score: -0.743024396 },
  { percentile: 0.14, z_score: -0.7121480798 },
  { percentile: 0.15, z_score: -0.6836126666 },
  { percentile: 0.16, z_score: -0.6573224817 },
  { percentile: 0.17, z_score: -0.6325188238 },
  { percentile: 0.18, z_score: -0.609461748 },
  { percentile: 0.19, z_score: -0.5877841349 },
  { percentile: 0.2, z_score: -0.5671609741 },
  { percentile: 0.21, z_score: -0.5474108563 },
  { percentile: 0.22, z_score: -0.5285988025 },
  { percentile: 0.23, z_score: -0.5109194584 },
  { percentile: 0.24, z_score: -0.4937404595 },
  { percentile: 0.25, z_score: -0.4770965084 },
  { percentile: 0.26, z_score: -0.4608524558 },
  { percentile: 0.27, z_score: -0.4452256089 },
  { percentile: 0.28, z_score: -0.4298842478 },
  { percentile: 0.29, z_score: -0.4151375075 },
  { percentile: 0.3, z_score: -0.4007590141 },
  { percentile: 0.31, z_score: -0.386512615 },
  { percentile: 0.32, z_score: -0.3726146396 },
  { percentile: 0.33, z_score: -0.3587867238 },
  { percentile: 0.34, z_score: -0.3451189522 },
  { percentile: 0.35, z_score: -0.3315259985 },
  { percentile: 0.36, z_score: -0.3181077649 },
  { percentile: 0.37, z_score: -0.3046679777 },
  { percentile: 0.38, z_score: -0.2912764961 },
  { percentile: 0.39, z_score: -0.2778822421 },
  { percentile: 0.4, z_score: -0.2644418415 },
  { percentile: 0.41, z_score: -0.250981294 },
  { percentile: 0.42, z_score: -0.2374801951 },
  { percentile: 0.43, z_score: -0.2239465852 },
  { percentile: 0.44, z_score: -0.2103734856 },
  { percentile: 0.45, z_score: -0.1964868972 },
  { percentile: 0.46, z_score: -0.1826956767 },
  { percentile: 0.47, z_score: -0.1686018434 },
  { percentile: 0.48, z_score: -0.1544100244 },
  { percentile: 0.49, z_score: -0.1399702806 },
  { percentile: 0.5, z_score: -0.125383862 },
  { percentile: 0.51, z_score: -0.1107784696 },
  { percentile: 0.52, z_score: -0.09573033477 },
  { percentile: 0.53, z_score: -0.08068818072 },
  { percentile: 0.54, z_score: -0.06519785537 },
  { percentile: 0.55, z_score: -0.04946514576 },
  { percentile: 0.56, z_score: -0.03360392526 },
  { percentile: 0.57, z_score: -0.01754790902 },
  { percentile: 0.58, z_score: -0.001080124261 },
  { percentile: 0.59, z_score: 0.01536729767 },
  { percentile: 0.6, z_score: 0.03241590033 },
  { percentile: 0.61, z_score: 0.04980434166 },
  { percentile: 0.62, z_score: 0.0676414752 },
  { percentile: 0.63, z_score: 0.08583656503 },
  { percentile: 0.64, z_score: 0.1046440488 },
  { percentile: 0.65, z_score: 0.1235281445 },
  { percentile: 0.66, z_score: 0.1432972132 },
  { percentile: 0.67, z_score: 0.1636188965 },
  { percentile: 0.68, z_score: 0.1845112268 },
  { percentile: 0.69, z_score: 0.2059391821 },
  { percentile: 0.7, z_score: 0.2280117478 },
  { percentile: 0.71, z_score: 0.2510331255 },
  { percentile: 0.72, z_score: 0.2750691841 },
  { percentile: 0.73, z_score: 0.2998591363 },
  { percentile: 0.74, z_score: 0.3255182901 },
  { percentile: 0.75, z_score: 0.3521676473 },
  { percentile: 0.76, z_score: 0.3800071762 },
  { percentile: 0.77, z_score: 0.4087041204 },
  { percentile: 0.78, z_score: 0.4388748282 },
  { percentile: 0.79, z_score: 0.470206547 },
  { percentile: 0.8, z_score: 0.5034125499 },
  { percentile: 0.81, z_score: 0.53811227 },
  { percentile: 0.82, z_score: 0.5743561584 },
  { percentile: 0.83, z_score: 0.613182777 },
  { percentile: 0.84, z_score: 0.6542618992 },
  { percentile: 0.85, z_score: 0.6979338376 },
  { percentile: 0.86, z_score: 0.7450781991 },
  { percentile: 0.87, z_score: 0.7958151398 },
  { percentile: 0.88, z_score: 0.8514983145 },
  { percentile: 0.89, z_score: 0.9123076579 },
  { percentile: 0.9, z_score: 0.9808283509 },
  { percentile: 0.91, z_score: 1.057675475 },
  { percentile: 0.92, z_score: 1.144399062 },
  { percentile: 0.93, z_score: 1.24448353 },
  { percentile: 0.94, z_score: 1.366546299 },
  { percentile: 0.95, z_score: 1.518344334 },
  { percentile: 0.96, z_score: 1.717427342 },
  { percentile: 0.97, z_score: 1.992137436 },
  { percentile: 0.98, z_score: 2.406876297 },
  { percentile: 0.99, z_score: 3.239616159 },
  { percentile: 1.0, z_score: 61.627364851 },
];
